__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/b96ea27/_next/";